<template>
  <div class="image-upload">
    <!-- 已上传图片预览 -->
    <div class="img-list">
      <div
        v-for="(item, index) in fileList"
        :key="index"
        class="img-item"
        :style="{ width: size + 'px', height: size + 'px' }"
      >
        <el-image :src="fullUrl(item)" fit="cover" class="img-thumb" :preview-src-list="previewList" />
        <div class="img-mask">
          <i class="el-icon-delete" @click="handleRemove(index)"></i>
        </div>
      </div>

      <!-- 上传按钮 -->
      <el-upload
        v-if="multiple || fileList.length === 0"
        class="img-uploader"
        :action="uploadUrl"
        :headers="uploadHeaders"
        :show-file-list="false"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        accept="image/*"
      >
        <i class="el-icon-plus img-uploader-icon" :style="{ fontSize: (size * 0.3) + 'px' }"></i>
      </el-upload>
    </div>
    <div v-if="tip" class="img-tip">{{ tip }}</div>
  </div>
</template>

<script>
import { Session } from '@/utils/storage';

export default {
  name: 'ImageUpload',
  props: {
    // 单图: 传 String; 多图: 传 Array
    value: {
      type: [String, Array],
      default: ''
    },
    // 是否多图
    multiple: {
      type: Boolean,
      default: false
    },
    // 多图最大数量
    limit: {
      type: Number,
      default: 20
    },
    // 单图最大体积(MB)
    maxSize: {
      type: Number,
      default: 10
    },
    tip: {
      type: String,
      default: ''
    },
    // 图片尺寸(px)
    size: {
      type: Number,
      default: 80
    }
  },
  data() {
    return {
      uploadUrl: '',
      uploadHeaders: {}
    };
  },
  computed: {
    // 统一转为数组处理
    fileList() {
      if (this.multiple) {
        return Array.isArray(this.value) ? this.value : [];
      }
      return this.value ? [this.value] : [];
    },
    previewList() {
      return this.fileList.map(item => this.fullUrl(item));
    }
  },
  created() {
    const token = Session.get('token');
    this.uploadUrl = (process.env.VUE_APP_BASE_API || '').replace(/\/$/, '') + '/admin/upload/cover?token=' + token;
  },
  methods: {
    // 相对路径拼接成可访问的完整地址
    fullUrl(url) {
      if (!url) return '';
      if (/^https?:\/\//.test(url)) return url;

      const base = process.env.VUE_APP_BASE_API || '';

      // 如果 base 是 '/' 或空字符串，直接返回原路径（走代理）
      if (base === '/' || base === '') {
        return url.startsWith('/') ? url : '/' + url;
      }

      // 否则拼接完整URL
      const cleanBase = base.replace(/\/$/, '');
      return cleanBase + (url.startsWith('/') ? url : '/' + url);
    },
    beforeUpload(file) {
      const isImage = file.type.indexOf('image/') === 0;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      const isLt = file.size / 1024 / 1024 < this.maxSize;
      if (!isLt) {
        this.$message.error(`图片大小不能超过 ${this.maxSize}MB!`);
        return false;
      }
      if (this.multiple && this.fileList.length >= this.limit) {
        this.$message.error(`最多上传 ${this.limit} 张图片!`);
        return false;
      }
      return true;
    },
    handleSuccess(response) {
      if (response.code === 0) {
        // 后端 /upload/cover 返回 { url, url_full }
        const url = response.data && response.data.url ? response.data.url : response.data;
        if (this.multiple) {
          const list = Array.isArray(this.value) ? [...this.value] : [];
          list.push(url);
          this.$emit('input', list);
        } else {
          this.$emit('input', url);
        }
        this.$message.success('上传成功');
      } else {
        this.$message.error(response.msg || '上传失败');
      }
    },
    handleRemove(index) {
      if (this.multiple) {
        const list = Array.isArray(this.value) ? [...this.value] : [];
        list.splice(index, 1);
        this.$emit('input', list);
      } else {
        this.$emit('input', '');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.image-upload {
  .img-list {
    display: flex;
    flex-wrap: wrap;
  }
  .img-item {
    position: relative;
    margin: 0 8px 8px 0;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #e4e7ed;
    .img-thumb {
      width: 100%;
      height: 100%;
      display: block;
    }
    .img-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.5);
      opacity: 0;
      transition: opacity 0.2s;
      i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
      }
    }
    &:hover .img-mask {
      opacity: 1;
    }
  }
  ::v-deep .img-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      border-color: #409eff;
    }
  }
  .img-uploader-icon {
    color: #8c939d;
  }
  .img-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
  }
}
</style>
